'use client';

import { LoadingIcon } from '@/components/icons/svg-icons';
import { OddsButton } from '@/components/widgets/odds-button';
import { useAccountInfo } from '@/hooks/query/account';
import { getTeamName } from '@/utils/odds-utils';
import { OutrightMarket, SportMatchModel } from '@nf/types/odds';
import { MatchOddsLoadingWrapper } from '../../match-odds-loading-wrapper';

interface OutrightListItemContentProps {
	match: SportMatchModel;
	markets: OutrightMarket[];
	teamNameMap?: Map<number, string>;
	isLoading: boolean;
}
export const OutrightListItemContent = ({
	match,
	markets,
	teamNameMap,
	isLoading,
}: OutrightListItemContentProps) => {
	const { user } = useAccountInfo();
	return (
		<MatchOddsLoadingWrapper isLoading={isLoading}>
			{
				markets.sort((a, b) => {
					// sort by odds & team name (不可使用 localeCompare, 因中英文混雜排序會不如預期)
					let compare = a.Price - b.Price;
					if (compare === 0) {
						const teamNameA = getTeamName(a.TeamId, teamNameMap);
						const teamNameB = getTeamName(b.TeamId, teamNameMap);
						if (teamNameA > teamNameB) {
							compare = 1;
						} else if (teamNameA < teamNameB) {
							compare = -1;
						}
					}
					return compare;
				}).map(market => (
					<div
						key={`outright_list_item_content${market.MarketId}`}
						className="match"
					>
						<div className="match__team">{getTeamName(market.TeamId, teamNameMap)}</div>
						<OddsButton
							key={market.MarketId}
							match={match}
							market={market}
							homeTeamName={''}
							awayTeamName={''}
							betTeam={''}
							originalPrice={market.Price}
							type="OT"
							sport={999}
							oddsType={user?.OType}
							accountStatus={user?.ActStatus ?? 0}
						/>
					</div>
				))
			}
		</MatchOddsLoadingWrapper>
	)
}